"use strict";
var Observable_1 = require('../../Observable');
var scan_1 = require('../../operator/scan');
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/scan.js